import { render, staticRenderFns } from "./AddDataObjectDialog.vue?vue&type=template&id=26f78e84&scoped=true&"
import script from "./AddDataObjectDialog.vue?vue&type=script&lang=js&"
export * from "./AddDataObjectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f78e84",
  null
  
)

export default component.exports